<template>
  <van-nav-bar
    title="缴费单"
    left-arrow
    @click-left="onClickLeft"
    fixed
    placeholder
  ></van-nav-bar>

  <div class="top">
    <div class="container">
      <div style="height: 10px"></div>
      <div class="student_info">
        <div class="info">
          <img src="../assets/default_profile.png" />
          <div class="student_desc">
            <span>{{ child_name }}</span>
            <span>{{ school_name }}</span>
            <span>{{ class_name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <van-empty v-if="listSize == 0" description="暂无缴费单" />
  <div v-if="listSize > 0" style="margin-bottom: 40px">
    <van-list
      v-model:loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      offset="10"
      @load="onLoad"
    >
      <van-cell-group
        inset
        v-for="item in list"
        :key="item.charge_no"
        style="margin-top: 5px"
        @click="toDetail(item)"
      >
        <van-cell :title="item.create_at">
          <template #value>
            <span :class="getStatusText(item.status).class">
              {{ getStatusText(item.status).text }}
            </span>
          </template>
        </van-cell>
        <van-cell :title="item.charge_name" :value="'¥' + item.payment" />
      </van-cell-group>
    </van-list>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { Toast } from "vant";
import { useRouter } from "vue-router";
import api from "../service/api";

export default {
  setup() {
    const active = ref(0);
    const list = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    // const route = useRoute(); //获取到值
    const router = useRouter(); //路由传值
    const payType = ref(1);
    const child_id = ref("");
    const child_name = ref("");
    const school_name = ref("");
    const class_name = ref("");
    const currentPage = ref(1);
    // const payText = ref("未缴费");
    const listSize = ref(1);

    const onClickLeft = () => {
      router.go(-1);
    };
    // --- 新增计算函数 ---

    const getStatusText = (status) => {
      switch (status) {
        case 1:
          return { text: "待缴费", class: "unpaid-status" };
        case 2:
          return { text: "缴费成功", class: "paid-status" };
        case 3:
          return { text: "线下缴费", class: "offline-status" };
        default:
          // 兜底：接口异常/未来新增状态时不至于 undefined.class 白屏
          return { text: "未知", class: "" };
      }
    };
    // --------------------

    onMounted(() => {
      if (getQuery("child_id")) {
        sessionStorage.setItem("childId", getQuery("child_id"));
        sessionStorage.setItem("childName", getQuery("child_name"));
        sessionStorage.setItem("schoolName", getQuery("school_name"));
        sessionStorage.setItem("className", getQuery("class_name"));
      }
      child_id.value = sessionStorage.getItem("childId");
      child_name.value = sessionStorage.getItem("childName");
      school_name.value = sessionStorage.getItem("schoolName");
      class_name.value = sessionStorage.getItem("className");
    });

    const toDetail = (item) => {
      router.push({
        path: "/paymentDetail",
        query: {
          charge_student_id: item.id,
        },
      });
    };

    const onLoad = () => {
      /**
       * wx_code 不为空时进行请求
       */
      finished.value = false;
      loading.value = true;
      api
        .getChargeList({
          student_id: child_id.value,
          page: currentPage.value,
        })
        .then((res) => {
          if (res.data.code == 1001) {
            if (currentPage.value == 1) {
              list.value = [];
            }
            let result = res.data.result;
            let payList = result.data;
            for (let i = 0; i < payList.length; i++) {
              list.value.push(payList[i]);
            }
            listSize.value = list.value.length;

            // 加载状态结束
            loading.value = false;
            currentPage.value++;

            // 数据全部加载完成
            if (list.value.length >= result.total) {
              finished.value = true;
            }
          } else if (res.data.code == 1002) {
            list.value = [];
            listSize.value = 0;
            finished.value = true;
          } else {
            listSize.value = 0;
            finished.value = true;
          }
        })
        .catch((err) => {
          finished.value = true;
          listSize.value = 0;
          Toast(err.message);
        });
    };

    function getQuery(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return decodeURI(pair[1]);
        }
      }
      return false;
    }

    return {
      list,
      onLoad,
      loading,
      finished,
      toDetail,
      active,
      payType,
      child_id,
      child_name,
      school_name,
      class_name,
      currentPage,
      // payText,
      listSize,
      onClickLeft,
      getStatusText, // 导出新函数
    };
  },
};
</script>

<style lang="less">
.top {
  position: sticky;
  top: 1px;
  z-index: 99;
  .container {
    height: 140px;
    background-color: #f2f2f2;
    .student_info {
      width: 94%;
      margin: 0 auto;
      height: 120px;
      border-radius: 6px;
      background-color: var(--color-primary);
      box-shadow: 0 2px 5px var(--color-primary);

      .info {
        display: block;
        width: 92%;
        height: 120px;
        margin: 0 auto;
        .changeBtn {
          float: right;
          margin-top: 20px;
          margin-right: 10px;
        }

        img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          margin-top: 4px;
          display: inline-block;
          overflow: hidden;
          margin-top: 30px;
        }
        .student_desc {
          display: inline-block;
          margin-left: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #fff;
          span {
            display: block;
            color: #fff;
            font-size: 14px;
            padding: 2px 0;
            text-align: left;
          }
        }
      }
    }
  }
}

/* 缴费状态颜色样式 */
.unpaid-status {
  color: #ff4d4f;
  font-weight: 500;
}

.paid-status {
  color: #52c41a;
  font-weight: 500;
}

.offline-status {
  color: #faad14;
  font-weight: 500;
}
</style>
